<template>
  <div class="kt-form kt-form--label-right">

    <div class="row">
      <div class="form-group col-md-4 validated px-5">
        <BaseRadioButtonGroup
          label="Type"
          :options="clientDetails.types"
          v-model="$v[validationGroupName].clientInformationTab.typeId.$model"
          @blur="$v[validationGroupName].clientInformationTab.typeId.$touch()"
          :validator="$v[validationGroupName].clientInformationTab.typeId"
          :disabled="isCompletedQuote" />
      </div>
      <div class="form-group col-md-4 validated px-5">
        <BaseInputForm
          type="text"
          label="Account name"
          placeholder="Ex. Doe Travel"
          v-model="$v[validationGroupName].clientInformationTab.accountName.$model"
          @blur="$v[validationGroupName].clientInformationTab.accountName.$touch()"
          :validator="$v[validationGroupName].clientInformationTab.accountName"
          :disabled="isCompletedQuote" />
      </div>
      <div class="form-group col-md-4 validated px-5">
        <BaseInputForm
          type="text"
          label="Contact name"
          placeholder="Ex. Jane Doe"
          v-model="$v[validationGroupName].clientInformationTab.contactName.$model"
          @blur="$v[validationGroupName].clientInformationTab.contactName.$touch()"
          :validator="$v[validationGroupName].clientInformationTab.contactName"
          :disabled="isCompletedQuote" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-4 validated px-5">
        <BaseInputForm
          type="text"
          label="Phone number"
          placeholder="Ex. (+1) 876590"
          v-model="$v[validationGroupName].clientInformationTab.phoneNumber.$model"
          @blur="$v[validationGroupName].clientInformationTab.phoneNumber.$touch()"
          :validator="$v[validationGroupName].clientInformationTab.phoneNumber"
          :disabled="isCompletedQuote" />
      </div>
      <div class="form-group col-md-4 validated px-5">
        <BaseInputForm
          type="text"
          label="Address"
          placeholder="Ex. Ave. Sezame 876"
          v-model="$v[validationGroupName].clientInformationTab.address.$model"
          @blur="$v[validationGroupName].clientInformationTab.address.$touch()"
          :validator="$v[validationGroupName].clientInformationTab.address"
          :disabled="isCompletedQuote" />
      </div>
      <div class="form-group col-md-4 validated px-5">
        <BaseInputForm
          type="text"
          label="Email"
          placeholder="Ex. jane@doe.travel"
          v-model="$v[validationGroupName].clientInformationTab.email.$model"
          @blur="$v[validationGroupName].clientInformationTab.email.$touch()"
          :validator="$v[validationGroupName].clientInformationTab.email"
          :disabled="isCompletedQuote" />
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ClientInformationTab',
  inject: ['$v'],
  computed: {
    ...mapGetters({
      'clientDetails': 'opportunity/clientDetails'
    })
  },
  props: {
    validationGroupName: {
      type: String,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    }
  }
}
</script>
